import * as React from "react";

import { cn } from "~/utils/fontsConfig";

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    prefixComponent?: React.ReactNode;
    suffixComponent?: React.ReactNode;
    wrapperClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            className,
            type,
            prefixComponent,
            suffixComponent,
            wrapperClassName,
            ...props
        },
        ref,
    ) => {
        return (
            <div
                className={cn(
                    "relative flex w-full items-center",
                    wrapperClassName,
                )}
            >
                {prefixComponent && (
                    <div className="absolute left-3 flex items-center">
                        {prefixComponent}
                    </div>
                )}
                <input
                    type={type}
                    className={cn(
                        "flex h-10 w-full rounded-[0.625rem] bg-v3-N-500 px-3 py-1 text-base tracking-wide shadow-none transition-colors",
                        "placeholder:text-v3-N-400",
                        "border border-transparent hover:border-v3-clover focus:border-v3-clover focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
                        "disabled:cursor-not-allowed disabled:opacity-50",
                        "md:text-sm",
                        prefixComponent && "pl-9",
                        suffixComponent && "pr-9",
                        className,
                    )}
                    ref={ref}
                    {...props}
                />
                {suffixComponent && (
                    <div className="absolute right-3 flex items-center">
                        {suffixComponent}
                    </div>
                )}
            </div>
        );
    },
);

Input.displayName = "Input";

export { Input };
